<template>
    <div v-if="visible">
        <el-dialog :visible.sync="visible"
                    :modal-append-to-body="false"
                    @close="close"
                    custom-class="large-dialog"
                    top="10vh"
                    width="1580px"
                    :destroy-on-close="true"
                    class="parent-dialog">
            <div class="head">
                <img src="@/assets/dialog/head-bg.png" alt="">
                <div class="text">{{ vdata.title }}</div>
            </div>
            <div class="list-content">
                <div class="list-head">
                    <div class="text" :style="{width: textnum + 'px'}" v-for="(item, i) in vdata.header" :key="i">
                        {{ item.name }}
                    </div>
                </div>
                <div class="list">
                    <div class="list-item" v-for="item in 10" :key="item" v-if="vdata.list[(pageIndex - 1) * 10 + item - 1]">
                        <div class="text" :style="{width: textnum + 'px'}" v-for="(del, i) in vdata.header" :key="i" :title="item[del.key]">
                            <div class="text">
                                {{ vdata.list[(pageIndex - 1) * 10 + item - 1][del.key] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <span>共{{ Math.ceil(vdata.list.length / 10) }}页</span>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="vdata.list.length"
                        :pager-count="5"
                        @current-change="currentChange"
                        :small="true">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        vdata: {
            type: [Object, Array],
            default: () => {}
        }
    },
    data() {
        return {
            visible: false,
            input1: '',
            value1: '',
            textnum: 127,
            total: 0,
            newvisible: false,
            pageIndex: 1
        }
    },
    computed: {
    },
    watch: {
        dialogVisible(n) {
            this.visible = n
        },
        vdata(n) {
            this.total = n.length
            this.$nextTick(() => {
                this.getWidth()
            })
        },
    },
    mounted() {
        this.getWidth()
    },
    methods: {
        close() {
            this.total = 0
            this.pageIndex = 1
            this.$emit('largeclose')
        },
        getWidth() {
            if (this.vdata.header && this.vdata.header.length) {
                const headnum = this.vdata.header.length
                if (headnum) {
                    this.textnum = 1356 / headnum
                } else {
                    setTimeout(() => {
                        this.getWidth() 
                    }, 200);
                }
            }
        },
        currentChange(e) {
            this.pageIndex = e
        },
    }
}
</script>

<style lang="scss">
.parent-dialog {
    background: transparent!important;
    backdrop-filter: blur(20px);
    z-index: 400;
}
.large-dialog {
    height: 797.5px;
    background: url(@/assets/dialog/large-bg.png) no-repeat !important;
    background-size: 100% 100% !important;
    .el-dialog__close {
        font-size: 27px;
        color: #C2E6FE !important;
    }
    .el-dialog__headerbtn {
        top: 60px;
        right: 100px;
    }
    .head {
        width: 100%;
        height: 70px;
        margin-top: 12px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .text {
            font-family: 'pmzd';
            font-weight: 400;
            font-size: 23px;
            color: #FFFFFF;
            line-height: 23px;
            position: relative;
            z-index: 1;
        }
        img {
           width: 605px;
           position: absolute;
        }
    }
    .status-list {
        position: absolute;
        right: 150px;
        color: #fff;
        display: flex;
        align-items: center;
        .status-title {
            color: #51A0F4;
            font-size: 16px;
        }
        .el-input__inner {
            border: 1px solid #054059 !important;
            background-color: #07182d !important;
            border-radius: 4px;
            color: #606266 !important;
        }
    }
    .search-input-group {
        position: absolute;
        left: 150px;
        color: #fff;
        display: flex;
        align-items: center;
        .el-input {
            width: 180px;
        }
        .el-input__inner {
            border: 1px solid #054059 !important;
            background-color: #07182d !important;
        }
        .searchbtn {
            margin-left: 16px;
            font-size: 16px;
            padding: 6px 12px;
            border-radius: 4px;
            background-color: #51A0F4;
            color: #fff;
            cursor: pointer;
        }
    }
    .list-content {
        width: 1356px;
        margin: 12px auto;
    }
    .list-head {
        display: flex;
        margin: 0 0 22px;
        .text {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #51A0F4;
            line-height: 16px;
            text-align: center;
        }
    }
    .list-item {
        padding: 14px 0;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #B3C7E9;
        line-height: 16px;
        display: flex;
        background: rgba(61, 98, 151, .2);
        margin-bottom: 4px;
        &:nth-child(2n) {
            background: rgba(61, 98, 151, .4);
        }
        .text {
            white-space: nowrap;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
        }
        .green {
            color: #00FD4A;
        }
        .red {
            color: #FF6C65;
        }
        .blue {
            color: #00CBFC;
        }
        .yellow {
            color: #FFE54A;
        }
    }
    .bottom {
        margin-top: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        >span {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #90D4FF;
            line-height: 14px;
        }
        .loadgroup {
            position: absolute;
            right: 0;
            display: flex;
            align-items: center;
            column-gap: 24px;
            .load-btn {
                font-size: 16px;
                padding: 4px 8px;
                border-radius: 4px;
                border: 1px solid #90D4FF;
                color: #90D4FF;
                cursor: pointer;
            }
        }
    }
    .el-pagination  {
        display: flex;
        justify-content: center;
        .btn-prev, .btn-next {
            background: transparent !important;
            color: #A6DAFF !important;
            border: 1px solid #1e4265;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
                color: #fff !important;
            }
        }
        .el-pager {
            li {
                color:  #A5B1BC !important;
                background: transparent !important;
                border: 1px solid #1e4265;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                &.active, &:hover {
                    color: #fff !important;
                    border-color: #1b5ba2;
                    background: #134379 !important;
                }
            }
        }
    }
    .state1 {
        color: #00FD4A;
        display: flex;
        align-items: center;
        .point {
            background: #00FD4A;
        }
    }
    .state2 {
        color: #00CBFC;
        display: flex;
        align-items: center;
        .point {
            background: #00CBFC;
        }
    }
    .state3 {
        color: #FFE54A;
        display: flex;
        align-items: center;
        .point {
            background: #FFE54A;
        }
    }
    .state4 {
        color: #FF6C65;
        display: flex;
        align-items: center;
        .point {
            background: #FF6C65;
        }
    }
    .toimg {
        color: #00CBFC;
        cursor: pointer;
    }
}
.img-dialog {
    .img-body {
        width: 100%;
        height: 720px;
        text-align: center;
    }
    .dialog-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>